<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        class="form-control border-0"
                        :options="optionEmployeeType"
                        v-model="search.employee_type"
                        label="name"
                        select-label=""
                        deselectLabel=""
                        placeholder="ประเภทพนักงาน"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        class="form-control border-0"
                        :options="optionPosition"
                        v-model="search.position"
                        label="department_name"
                        select-label=""
                        multiple
                        style="height: 100%"
                        :closeOnSelect="false"
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        class="form-control border-0"
                        :options="optionEmployee"
                        v-model="search.employee"
                        :customLabel="employeeLabel"
                        select-label=""
                        multiple
                        style="height: 100%"
                        :closeOnSelect="false"
                        deselectLabel=""
                        placeholder="พนักงาน"
                        track-by="id">
                    </multiselect>
                    <date-picker v-model="search.date"
                                 range
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang" confirm>
                    </date-picker>
                    <b-form-select
                        :options="optionActive"
                        v-model="search.active">
                    </b-form-select>
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchEmployee">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp

                    <button class="btn btn-primary my-2 my-sm-0 ml-2"
                            @click="searchFilterWork"
                            type="button">
                        <icon name="print"></icon>
                        รายงานวันลาหยุด
                    </button>
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อ-สกุล</th>
                    <th scope="col">ตารางทำงาน</th>
                    <th scope="col">แผนก</th>
                    <th scope="col">อายุงาน</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">วันทำงานทั้งหมด</th>
                    <th scope="col">วันหยุด</th>
                    <th scope="col">วันที่ขอลา</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in workScheduleList">
                    <td>{{ data.employee_no }}</td>
                    <td>{{ data.name }}</td>
                    <td>
                        <template v-if="data.occupation">
                            <span v-if="data.occupation.shift">{{ data.occupation.shift.name }}</span>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.occupation && data.occupation.position">
                            {{ data.occupation.position.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.work_year }}</td>
                    <td>
                        <template v-if="data.work_status">
                            {{ data.work_status.active_status_id == 1 ? 'พนักงาน' : (data.work_status.active_status_id == 2 ? 'ลาออก' : '-') }}
                        </template>
                    </td>
                    <td>{{ data.workday }}</td>
                    <td>{{ data.holiday }}</td>
                    <td>
                        <a @click="goToWorkScheduleForm(data.id)" style="text-decoration: underline; color: #00a699">
                            {{ data.leave_day_text }}
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="workScheduleList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getWorkScheduleList">
            </vue-pagination>
        </div>
        <br>
        <!--        <pre class="alert alert-primary">{{workScheduleList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import VuePagination from "../../../Pagination";
import DatePicker from 'vue2-datepicker';
import moment from "moment";
import {domain} from "../../../../util/Constants";

export default {
    name: "work-schedule-list",
    components: {
        Multiselect,
        VuePagination,
        DatePicker,
    },
    created() {
        this.$store.dispatch("WorkScheduleEmployee/setWorkScheduleList");
        this.$store.dispatch("WorkScheduleEmployee/clearSearch");
        this.$store.dispatch("Common/setEmployeeType");
        this.$store.dispatch("Department/getAllDepartment")
        this.getEmployeeAll();
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            workScheduleList: state => {
                return state.WorkScheduleEmployee.workScheduleList;
            },
            optionPosition: state => {
                return state.Department.optionList
            },
            optionEmployeeType: state => {
                return state.Common.employee_type
            },
            search: state => {
                return state.WorkScheduleEmployee.search
            },
            dataPaginate: state => {
                return state.WorkScheduleEmployee.dataPaginate;
            },
        })
    },
    data() {
        return {
            event_submit: false,
            optionEmployee: [],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            optionActive: [
                {text: "เลือกสถานะ", value: ""},
                {text: 'พนักงาน', value: 1},
                {text: 'ลาออก', value: 2},
            ],
        };
    },
    methods: {
        searchFilterWork() {
            let start_date = this.search.date.length > 0 && this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '';
            let end_date = this.search.date.length > 0 && this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '';
            let active = this.search.active;
            let id_employee = '';
            let id_department = '';
            this.search.employee.forEach((a, i) => {
                this.search.employee.length == i + 1 ? id_employee = id_employee + a.id : id_employee = id_employee + a.id + ',';
            })
            this.search.position.forEach((a, i) => {
                this.search.position.length == i + 1 ? id_department = id_department + a.id : id_department = id_department + a.id + ',';
            })
            window.open(`${domain}/searchWorkScheduleEmployee?id_employee=${id_employee}&id_department=${id_department}&date_start=${start_date}&date_end=${end_date}&active=${active}`);
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        getEmployeeAll() {
            this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                this.optionEmployee = res;
            })
        },
        goToWorkScheduleForm(id) {
            this.$store.dispatch("WorkScheduleEmployee/showWorkScheduleByEmployee", id).then(() => {
                this.$store.dispatch("Employee/getEmployeeByID", id).then(() => {
                    this.$router.push({
                        name: "work-schedule-form",
                        params: {id}
                    })
                })
            })
        },
        searchEmployee() {
            this.event_submit = true;
            let employee_id = [];
            let position_id = [];
            this.search.employee.forEach(a => {
                employee_id.push(a.id)
            })
            this.search.position.forEach(a => {
                position_id.push(a.id)
            })
            let data = {
                employee_id: employee_id,
                position_id: position_id,
                type_id: this.search.employee_type ? this.search.employee_type.id : '',
                date_start: this.search.date.length > 0 && this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                date_end: this.search.date.length > 0 && this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                active: this.search.active,
            };
            this.$store.dispatch("WorkScheduleEmployee/searchEmployeeWorkSchedule", data);
        },
        getWorkScheduleList() {
            const page = this.dataPaginate.current_page;
            //paginate search
            if (this.event_submit) {
                let data = {
                    employee_id: this.search.employee ? this.search.employee.id : '',
                    position_id: this.search.position ? this.search.position.id : '',
                    type_id: this.search.employee_type ? this.search.employee_type.id : '',
                }
                this.$store.dispatch("WorkScheduleEmployee/searchEmployeeWorkSchedule", data);
            }
            //paginate get data
            else {
                this.$store.dispatch("WorkScheduleEmployee/setWorkScheduleList", page);
            }
        }
    }
}
</script>

<style scoped>

</style>
